// extracted by mini-css-extract-plugin
module.exports = {"resendCode":"ResendCode_resendCode__1NnsM","textRow":"ResendCode_textRow__AGxpi"};